<script lang="ts">
  import Tab from "../../components/Tab/Tab.svelte";
  import Tabs from "../../components/Tab/Tabs.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import SettingsClfFragment from "./SettingsClfFragment.svelte";
  import SettingsCustomFieldsFragment from "./SettingsCustomFieldsFragment.svelte";
  import SettingsCustomListSchemasFragment from "./SettingsCustomListSchemasFragment.svelte";
  import SettingsCustomListValuesFragment from "./SettingsCustomListValuesFragment.svelte";
  import SettingsCustomListOwnershipsFragment from "./SettingsCustomListOwnershipsFragment.svelte";
  import SettingsGeneralFragment from "./SettingsGeneralFragment.svelte";
  import SettingsSrlFragment from "./SettingsSrlFragment.svelte";

  enum SettingPage {
    General = 1,
    Classifications,
    CustomFields,
    CustomListSchemas,
    CustomListValues,
    StatusRules,
    MailTemplates,
    MailServers,
    Ownerships,
  }

  let currentTab: SettingPage = SettingPage.General;
</script>

<MainLayout>
  <Tabs>
    <Tab
      label="Generale"
      active={currentTab == SettingPage.General}
      on:click={(_) => {
        currentTab = SettingPage.General;
      }}
    />
    <Tab
      label="Dizionari"
      active={currentTab == SettingPage.Classifications}
      on:click={(_) => {
        currentTab = SettingPage.Classifications;
      }}
    />
    <Tab
      label="Campi Personalizzati"
      active={currentTab == SettingPage.CustomFields}
      on:click={(_) => {
        currentTab = SettingPage.CustomFields;
      }}
    />
    <Tab
      label="Definizione Tabelle Personalizzate"
      active={currentTab == SettingPage.CustomListSchemas}
      on:click={(_) => {
        currentTab = SettingPage.CustomListSchemas;
      }}
    />
    <Tab
      label="Valori Tabelle Personalizzate"
      active={currentTab == SettingPage.CustomListValues}
      on:click={(_) => {
        currentTab = SettingPage.CustomListValues;
      }}
    />
    <Tab
      label="Regole Workflow"
      active={currentTab == SettingPage.StatusRules}
      on:click={(_) => {
        currentTab = SettingPage.StatusRules;
      }}
    />
    <Tab
      label="Ragioni sociali"
      active={currentTab == SettingPage.Ownerships}
      on:click={(_) => {
        currentTab = SettingPage.Ownerships;
      }}
    />
    <!--
    <Tab
      label="Template E-Mail"
      active={currentTab == SettingPage.MailTemplates}
      on:click={(_) => {
        currentTab = SettingPage.MailTemplates;
      }}
    />
    <Tab
      label="Server E-Mail"
      active={currentTab == SettingPage.MailServers}
      on:click={(_) => {
        currentTab = SettingPage.MailServers;
      }}
    />
    -->
  </Tabs>

  {#if currentTab == SettingPage.General}
    <SettingsGeneralFragment />
  {/if}

  {#if currentTab == SettingPage.Classifications}
    <SettingsClfFragment />
  {/if}

  {#if currentTab == SettingPage.CustomFields}
    <SettingsCustomFieldsFragment />
  {/if}

  {#if currentTab == SettingPage.CustomListSchemas}
    <SettingsCustomListSchemasFragment />
  {/if}

  {#if currentTab == SettingPage.CustomListValues}
    <SettingsCustomListValuesFragment />
  {/if}

  {#if currentTab == SettingPage.StatusRules}
    <SettingsSrlFragment />
  {/if}

  {#if currentTab == SettingPage.Ownerships}
    <SettingsCustomListOwnershipsFragment />
  {/if}

</MainLayout>
